const pronouns: Array<string> = ['She/Her', 'He/Him', 'They/Them', 'Xe/Xem', 'Ze/Zir'];
export default pronouns;
